import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useDivisionsContainerStyles = makeStyles((theme: Theme) => ({
	root: {
		marginLeft: 24,
		[theme.breakpoints.down('lg')]: {
			marginLeft: 0,
			marginTop: 16,
		},
	},
	title: {
		paddingBottom: 16,
		paddingRight: 30,
		paddingTop: 32,
	},
	divisionsContainer: {
		paddingBottom: 24,
		paddingRight: 24,
		overflowX: 'hidden',
		overflowY: 'auto',
		scrollbarColor: '#c7c7c7 #E9E9E9',
		scrollbarWidth: 'thin',
		width: '100%',
		'&::-webkit-scrollbar': {
			width: 6,
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#E9E9E9',
			borderRadius: 7,
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#c7c7c7',
			borderRadius: 7,
		},
	},
	divisionsContainerEmpty: {
		paddingBottom: 0,
		paddingRight: 0,
	},
	scrollContainer: {
		display: 'flex',
		flexFlow: 'row wrap',
		gap: 8,
		width: '100%',
	},
}));

export default useDivisionsContainerStyles;
